import React from "react";
import CommentInput from "./CommentInput";
import CommentsShow from "./CommentsShow";
import commentSectionStyles from "../../styles/CommentSection.module.css";

function CommentsSection({ postId, onCommentAdded, isOwner }) {
  return (
    <div className={commentSectionStyles.commentSectionContainer}>
      <div className={commentSectionStyles.commentButtonContainer}>
        {!isOwner && (
          <CommentInput postId={postId} onCommentAdded={onCommentAdded} />
        )}
      </div>
      <div className={commentSectionStyles.commentShowContainer}>
        <CommentsShow postId={postId} />
      </div>
    </div>
  );
}

export default CommentsSection;
